/**
 * NIE GENAU EIN TO-DO (User 03.11.2026): „wenn nur ein todo übrig bleibt, dann
 * muss das todo zum vorgang, also ein vorgang ohne todos".
 *
 * Gefaltet wird im Server (`TodoService.stelleTodoFormHer`) — hier steht nur,
 * was die Seite VORHER dazu sagt, damit niemand überrascht ist, wenn nach dem
 * Entfernen statt einer To-do-Karte der Vorgang selbst dasteht.
 */

/** Bleibt nach dem Entfernen genau EIN To-do übrig? Dann wird es der Vorgang. */
export function letztesTodoWirdVorgang(andereTodos: number): boolean {
    return andereTodos === 1;
}

/** Der Rückfragetext beim Entfernen eines To-dos. */
export function entfernenText(titel: string, andereTodos: number): string {
    const satz = `„${titel}“ wird aus dem Vorgang entfernt.`;
    return letztesTodoWirdVorgang(andereTodos)
        ? `${satz} Danach bleibt nur noch ein To-do — es wird wieder der Vorgang selbst, mit allem, was daran hängt.`
        : satz;
}
